import { render, staticRenderFns } from "./homeA.vue?vue&type=template&id=e8de8428&scoped=true&"
import script from "./homeA.vue?vue&type=script&lang=js&"
export * from "./homeA.vue?vue&type=script&lang=js&"
import style0 from "./homeA.vue?vue&type=style&index=0&id=e8de8428&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8de8428",
  null
  
)

export default component.exports